import React, { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useInternetSpeedMeasurer } from '@hooks/useInternetSpeedMeasurer';
import ProjectsLayout from '@widgets/projects-layout/ProjectsLayout';

const HomePage = () => {
    useInternetSpeedMeasurer();
    const navigate = useNavigate();

    const projectClickHandler = useCallback((projectId: string) => {
        navigate(`./${projectId}`);
    }, []);

    const onProjectCreation = useCallback((projectId: string) => {
        navigate(`/${projectId}`);
    }, []);

    return (
        <ProjectsLayout
            projectClickHandler={projectClickHandler}
            onProjectCreation={onProjectCreation}
        />
    );
};

export default HomePage;
